export const NEXT_PUBLIC_BASE_URL = "https://kimia-shop.ir/";
export const NEXT_PUBLIC_BASE_PREFIX = "api/web/v1/warehousing";
